import { useQuery } from "@apollo/client/react";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";

import { constantsData, urlsData } from "@/data";
import { getTrackBulkUpdateStatusQuery } from "@/graph";
import { openAlert } from "@/redux/actions";
import { displayErrorHandler } from "@/utils";

const useGetBulkUpdateTrackStatus = (id) => {
    const { isAuthenticated } = useAuth0();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { data, error, loading, startPolling, stopPolling } = useQuery(getTrackBulkUpdateStatusQuery, {
        skip: !isAuthenticated,
        variables: {
            jobId: id,
        },
    });

    useEffect(
        () => {
            if (!data?.getTrackBulkUpdateStatus) {
                if (!loading) navigate(urlsData.routes.notFound);
                return;
            }
            if (data.getTrackBulkUpdateStatus.status === "completed") stopPolling();
        },
        [data, loading], // eslint-disable-line
    );

    useEffect(() => {
        if (error?.message === constantsData.failedToFetch && !loading) {
            displayErrorHandler(t("messages.networkFailure"), dispatch, openAlert);
        }
    }, [error]); // eslint-disable-line

    useEffect(() => {
        if (
            data?.getTrackBulkUpdateStatus?.status &&
            data.getTrackBulkUpdateStatus.status !== "completed" &&
            data.getTrackBulkUpdateStatus.status !== "failed"
        )
            startPolling(3000);

        // Cleanup: stop polling on unmount
        return () => {
            stopPolling();
        };
    }, [data?.getTrackBulkUpdateStatus?.status, startPolling, stopPolling]);

    return {
        data: data?.getTrackBulkUpdateStatus,
        loading,
    };
};

export default useGetBulkUpdateTrackStatus;
